import Component from 'flarum/common/Component';
/**
 * Item de navegação visualmente idêntico a um LinkButton do Flarum que
 * revela um submenu ao hover. A visibilidade é controlada via JS (classe
 * `is-open`) com delay de 180ms no mouseleave para dar tempo do mouse
 * atravessar o gap trigger→submenu sem fechar no meio do caminho.
 * Controlar via CSS `:hover` puro não funciona porque `display:none`
 * remove o elemento do hit-test e quebra a cadeia de hover.
 */
export default class MpHoverNavItem extends Component {
  open = false;
  closeTimer = null;
  openTimer = null;
  view(vnode) {
    const {
      href,
      icon,
      label,
      subItems
    } = vnode.attrs;
    const active = this.isActiveLink(href) || subItems.some(s => this.isActiveLink(s.href));
    const cls = ['MpHoverNavItem'];
    if (active) cls.push('is-active');
    if (this.open) cls.push('is-open');
    return m("div", {
      className: cls.join(' '),
      onmouseenter: () => this.show(),
      onmouseleave: () => this.scheduleHide()
    }, m("a", {
      className: "LinkButton hasIcon MpHoverNavItem-trigger",
      href: href,
      config: m.route.link,
      onfocus: () => this.show(),
      onblur: () => this.scheduleHide()
    }, m("i", {
      "aria-hidden": "true",
      className: 'icon ' + icon + ' Button-icon'
    }), m("span", {
      className: "Button-label"
    }, m("span", {
      className: "Button-labelText"
    }, label))), m("ul", {
      className: "MpHoverNavItem-submenu",
      role: "menu",
      onmouseenter: () => this.show(),
      onmouseleave: () => this.scheduleHide()
    }, subItems.map(it => m("li", {
      key: it.href,
      role: "none"
    }, m("a", {
      role: "menuitem",
      className: "LinkButton hasIcon",
      href: it.href,
      config: m.route.link,
      onclick: e => {
        this.hideNow();
        it.onclick?.(e);
      }
    }, m("i", {
      "aria-hidden": "true",
      className: 'icon ' + it.icon + ' Button-icon'
    }), m("span", {
      className: "Button-label"
    }, m("span", {
      className: "Button-labelText"
    }, it.label)))))));
  }
  show() {
    // Cancela qualquer fechamento pendente.
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    if (this.open) return;
    // Delay de abertura: ignora passes rápidos do mouse pelo botão
    // (movimento "de passagem" não deve abrir o submenu — só hovers
    // intencionais com >=90ms de permanência).
    if (this.openTimer) return;
    this.openTimer = setTimeout(() => {
      this.openTimer = null;
      this.open = true;
      m.redraw();
    }, 90);
  }
  scheduleHide() {
    // Se o usuário saiu antes do delay de abrir terminar, simplesmente
    // cancela o open pendente — nada foi aberto, nada para fechar.
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
    if (this.closeTimer) clearTimeout(this.closeTimer);
    // Delay generoso: dá tempo do mouse atravessar o gap até o submenu
    // ou voltar pro trigger (especialmente útil quando o usuário move
    // o mouse de baixo pra cima — o cursor passa pela área do submenu).
    this.closeTimer = setTimeout(() => this.hideNow(), 320);
  }
  hideNow() {
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    if (this.open) {
      this.open = false;
      m.redraw();
    }
  }
  onremove() {
    if (this.openTimer) clearTimeout(this.openTimer);
    if (this.closeTimer) clearTimeout(this.closeTimer);
  }
  isActiveLink(href) {
    try {
      const current = m.route.get?.() || window.location.pathname;
      if (!current) return false;
      const clean = current.split('?')[0];
      const target = href.split('?')[0];
      return clean === target;
    } catch {
      return false;
    }
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/MpHoverNavItem', MpHoverNavItem);